
import * as React from 'react';
import './editModalHeader.scss';
import { ILabEmployee } from 'typings/employeeErrorData';

interface EditModalHeaderProps {
    labEmployee: Nullable<ILabEmployee>;
    errorDetails: { [id: string]: string };
}

export default class EditModalHeader extends React.Component<EditModalHeaderProps, {}> {
    constructor(props: EditModalHeaderProps) {
        super(props);
        this.renderWarning = this.renderWarning.bind(this);
    }

    render(): JSX.Element {
        const { labEmployee, errorDetails } = this.props;
        const nameError = errorDetails.firstName && errorDetails.lastName;
        const nameDisplayText = nameError
            ? 'Unknown Employee Name'
            : `${labEmployee?.firstName} ${labEmployee?.lastName}`;

        return (
            <div className="nomst-edit-modal-header">
                <h2>
                    Edit Employee - {nameDisplayText}
                </h2>
                <div className="nomst-edit-modal-header__field">
                    <span id="employeeId" className="nomst-edit-modal-header__field-label">Employee ID</span>
                    {labEmployee?.employeeNumber
                        && !errorDetails.employeeNumber
                        && <span id="employeeIdValue" className="nomst-edit-modal-header__field-label">{labEmployee.employeeNumber}</span> }
                    {errorDetails.employeeNumber
                        && this.renderWarning(errorDetails.employeeNumber, 'Upload required to change Employee ID')}
                </div>
            </div>
        );
    }

    private renderWarning(
        error?: Nullable<string>,
        errorMessage?: Nullable<string>): JSX.Element {
        const errorToDisplay = error ? errorMessage : '';

        return (
            <span className="nomst-edit-modal-header__field-warning">{errorToDisplay}</span>
        );
    }
}
